document.addEventListener('DOMContentLoaded', function() {
    let totalSum = 0;
    let productsProcessed = 0;
    let totalProducts = 0;

    const vinInput = document.getElementById('vin-input');
    const vinStatus = document.getElementById('vin-status');
    const submitButton = document.getElementById('vin-submit-button');
    const displayArea = document.getElementById('display-area');
    let isRequestInProgress = false;

    // Check that the elements are being correctly identified
    console.log('vinInput:', vinInput);
    console.log('vinStatus:', vinStatus);
    console.log('submitButton:', submitButton);
    console.log('displayArea:', displayArea);

    function updateVinStatus(vin) {
        const now = new Date();
        if (vinStatus) {
            vinStatus.innerHTML = `You are checking: <span id="vin-number">${vin}</span> - Checked at <span id="vin-check-date">${now.toLocaleDateString()}, ${now.toLocaleTimeString()}</span>`;
        } else {
            console.error('vinStatus element not found');
        }
    }

    function sendDataToFlask(inputData) {
        if (displayArea) {
            displayArea.innerHTML = '<p>Loading... Please wait. This may take a minute or two.</p>';
        } else {
            console.error('displayArea element not found');
            return;
        }

        console.log('Sending VIN to Flask API:', inputData);

        fetch('https://api.cleanvinusa.com/check-vin', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ vin: inputData })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            return response.json();
        })
        .then(data => {
            console.log('Received data:', data); // Log the data to inspect its structure
            displayData(data, inputData);
        })
        .catch(error => {
            console.error('Error:', error);
            if (displayArea) {
                displayArea.innerHTML = '<p>Error loading data. Please try again.</p>';
            }
        })
        .finally(() => {
            isRequestInProgress = false;
            submitButton.disabled = false;
        });
    }

    function fetchProductAndDisplay(productHandle, vin) {
        console.log('Fetching product:', productHandle);

        return fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok.');
                }
                return response.json();
            })
            .then(product => {
                console.log('Fetched product data:', product);
                renderProduct(product, vin);
            })
            .catch(error => console.error(`Error fetching product ${productHandle}:`, error));
    }

    function renderProduct(product, vin) {
        try {
            console.log('Rendering product:', product);

            const productPrice = parseFloat(product.variants[0].price) / 100;
            totalSum += productPrice;
            productsProcessed++;

            if (!displayArea) {
                console.error('Display area not found');
                return;
            }

            let table = document.getElementById('product-table');
            if (!table) {
                table = document.createElement('table');
                table.id = 'product-table';
                table.innerHTML = `
                    <thead>
                        <tr>
                            <th>Site Logo</th>
                            <th>Description</th>
                            <th>Price</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                `;
                const tableContainer = document.createElement('div');
                tableContainer.classList.add('table-container');
                tableContainer.appendChild(table);
                displayArea.appendChild(tableContainer);
            }

            const productUrl = window.Shopify.routes.root + `products/${product.handle}`;
            const formattedPrice = `$${productPrice.toFixed(2)}`;
            const productId = product.variants[0].id;
            const vinValue = vinInput.value.trim();
            const row = table.querySelector('tbody').insertRow();
            row.innerHTML = `
                <td><a href="${productUrl}" target="_blank"><img src="${product.images[0]}" alt="${product.title}" class="product-image"></a></td>
                <td>${product.title}</td>
                <td style="font-weight: bold;">${formattedPrice}</td>
                <td>Your VIN is visible on this site or this site in Google</td>
                <td>
                    <form method="post" action="/cart/add" class="add-to-cart-form" data-product-id="${productId}">
                        <input type="hidden" name="id" value="${productId}" />
                        <input min="1" type="hidden" name="quantity" value="1"/>
                        <input type="hidden" id="vin-${productId}" name="properties[vin]" value="${vinValue}">
                        <button type="submit" class="add-to-cart-button">Add to Cart</button>
                    </form>
                </td>
            `;

            row.querySelector('.add-to-cart-form').addEventListener('submit', function(event) {
                event.preventDefault();
                const formData = new FormData(this);
                ajaxAddToCart(formData, productId);
            });
        } catch (error) {
            console.error('Error rendering product:', error);
        }
    }

    function displayTotalAndAddAllButton() {
        if (!displayArea) {
            console.error('Display area not found');
            return;
        }

        const table = document.getElementById('product-table');
        if (!table) {
            console.error('Table not found');
            return;
        }

        const formattedTotal = `$${totalSum.toFixed(2)}`;
        const totalRow = table.querySelector('tbody').insertRow();
        totalRow.innerHTML = `
            <td colspan="3">Total</td>
            <td></td>
            <td style="font-weight: bold;">${formattedTotal}</td>
        `;

        const addButton = document.createElement('button');
        addButton.textContent = 'Add All to Cart';
        addButton.onclick = function() {
            addAllProductsToCart();
        };
        displayArea.appendChild(addButton);
    }

    function addAllProductsToCart() {
        const forms = document.querySelectorAll('.add-to-cart-form');
        addProductsSequentially(Array.from(forms), 0, 0);
    }

    function addProductsSequentially(forms, index, successfulAdds) {
        if (index >= forms.length) {
            alert(`${successfulAdds} products have been added to the cart.`);
            return;
        }

        const formData = new FormData(forms[index]);
        ajaxAddToCart(formData)
            .then(() => {
                addProductsSequentially(forms, index + 1, successfulAdds + 1);
            })
            .catch(error => {
                console.error('Error adding product to cart:', error);
                addProductsSequentially(forms, index + 1, successfulAdds); // Continue with next product even if current fails
            });
    }

    function displayData(responseJson, vin) {
        console.log('Displaying data for VIN:', vin);

        const productHandles = responseJson.product_info[0]; // Adjusted to use the correct index for product handles
        totalProducts = productHandles.length;
        totalSum = 0;
        productsProcessed = 0;

        if (!displayArea) {
            console.error('Display area not found');
            return;
        }

        displayArea.innerHTML = '';
        
        const now = new Date();
        const dateStr = now.toLocaleDateString();
        const timeStr = now.toLocaleTimeString();
        const vinHeader = document.createElement('h3');
        vinHeader.textContent = `You are checking: ${vin} - Checked at ${dateStr}, ${timeStr}`;
        displayArea.appendChild(vinHeader);

        const fetchPromises = productHandles.map(handle => fetchProductAndDisplay(handle, vin));

        Promise.all(fetchPromises)
            .then(() => displayTotalAndAddAllButton())
            .catch(error => console.error('Error fetching products:', error));
    }

    if (submitButton) {
        submitButton.addEventListener('click', function(event) {
            event.preventDefault();
            if (isRequestInProgress) {
                console.log('A request is already in progress.');
                return;
            }
            if (vinInput && vinInput.value) {
                isRequestInProgress = true;
                submitButton.disabled = true;
                sendDataToFlask(vinInput.value.trim());
                updateVinStatus(vinInput.value.trim());
            } else {
                alert('Please enter a VIN number.');
            }
        });
    } else {
        console.error('Submit button not found');
    }

    function ajaxAddToCart(formData) {
        return new Promise((resolve, reject) => {
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok.');
                }
                return response.json();
            })
            .then(data => {
                console.log('Product added to cart:', data);
                resolve(data);
            })
            .catch(error => {
                console.error('Error adding product to cart:', error);
                reject(error);
            });
        });
    }
});
